<!--  -->
<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>渠道</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">渠道列表</div>
        <!-- <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="searchPro"
          style="width:230px;margin-top:20px;"
        /> -->
      </div>
      <div class="header-tool-box" >
        <div class="htb-item"@click="show = true">
          <i class="icon iconfont icon-downLoad2"></i><span>添加渠道</span>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent">
      <div v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="name">{{
            row.name
          }}</template>
          <template slot-scope="{ row }" slot="spectatorCount">{{
            row.spectatorCount
          }}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff; cursor: pointer" @click="QRShow(row)"
              >查看二维码</span
            >
            <!-- <span style="display: inline-block; padding: 0 5px">|</span>
            <Poptip
              confirm
              title="确认是否删除?"
              @on-ok="delItem(row)"
              :transfer="true"
            >
              <span style="color: #f00; cursor: pointer">删除</span>
            </Poptip> -->
            
          </template>
        </Table>
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <iModal
      title="添加渠道"
      v-model="show"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="show = false"
      @on-ok='addChannel()'
    >
    <Form
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      label-position="left"
      :label-width="50"
    >
    
      <FormItem label="名称" prop="FirstName">
        <Input type="text" v-model="formInline.Name"></Input>
      </FormItem>
    </Form>
    </iModal>
        <iModal
      title="二维码"
      v-model="QRshow"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="QRshow = false"
     
    >
    <img :src="path" >
    </iModal>
    
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          title: "渠道",
          slot: "name",
          align: "center",
          //width: 240
        },
        {
          title: "数量",
          slot: "spectatorCount",
          align: "center",
          //width: 240
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      list: [],
      pageSize: 10,
      pageIndex: 1,
      totalCount: "",
      show: false,
      formInline: {
        Name: "",
      },
      ruleInline: {
        Name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
      },
      QRshow:false,
      path:''
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getChannelList: "hostCommonModule/getChannelList",
      AddChannel:"hostCommonModule/AddChannel"
    }),
    async init() {
      let opt = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        
        Wheres: {
          Type: 1,
          Wheres: {
            Label: "targetType",
            Value: "4",
          },
        },
      };
      let data = await this.getChannelList(opt);
      if (data && data.items && data.items.length > 0) {
        this.list = data.items;
        this.totalCount=data.totalCount
      }
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    QRShow(row){
        this.QRshow=true
        this.path=row.path
    },
    async addChannel(){
        let opt={
            name:this.formInline.Name
        }
        let data=await this.AddChannel(opt)
        console.log(data,'添加的渠道');
    }
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
</style>